import React from "react";
import { useApp } from "@/contexts/AppContext";
import { Truck, Shield, CreditCard } from "lucide-react";

export default function Footer() {
  const { t, lang } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 border-t border-border bg-surface print-hide">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <Feature
          icon={<Truck className="h-5 w-5" />}
          title={t.f1Title}
          desc={t.f1Desc}
        />
        <Feature
          icon={<Shield className="h-5 w-5" />}
          title={t.f2Title}
          desc={t.f2Desc}
        />
        <Feature
          icon={<CreditCard className="h-5 w-5" />}
          title={t.f3Title}
          desc={t.f3Desc}
        />
      </div>
      <div className="border-t border-border py-6">
        <div className="max-w-7xl mx-auto px-4 text-sm text-muted-foreground flex justify-between flex-wrap gap-2">
          <span>© {year} {t.brand}. {lang === "ar" ? "جميع الحقوق محفوظة." : "All rights reserved."}</span>
          <span>{t.storeAddress}</span>
        </div>
      </div>
    </footer>
  );
}

const Feature = ({ icon, title, desc }) => (
  <div className="flex gap-4 items-start">
    <div className="h-10 w-10 rounded-lg bg-accent text-accent-foreground flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <div>
      <h4 className="font-semibold text-sm">{title}</h4>
      <p className="text-sm text-muted-foreground mt-1">{desc}</p>
    </div>
  </div>
);
